<template>
  <v-dialog v-model="dialog" max-width="560">
      <v-card>
          <v-card-title>Edit Product line</v-card-title>
          <v-card-text>
               <v-form ref="addForm">
                    <ProductAutocomplete v-model="model.product_id" @productSelected="setProduct($event)" :rules="[rules.required]" />
                    <v-text-field v-model="model.quantity" label="Quantity" :rules="[rules.required]" />
                    <v-text-field v-model="model.cost" label="Unit Cost" :suffix="currency" :rules="[rules.required]" />
               </v-form>
          </v-card-text>
          <v-card-actions>
              <v-btn @click="close">Close</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="update">Update</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import ProductAutocomplete from "../forms/autocomplete/Product.vue"
export default {
    name:"EditProduct",
    components:{
        ProductAutocomplete
    },
    data: () => ({
        dialog:false,
        product:null,
        model: {
            product_id: null,
            quantity: null,
            cost: 0
        },
        
        rules: {
            required: value => !!value || "This field is mandatory.",
        },
    }),
    props:{
        currency:{
            type:String,
            default:''
        }
    },
    methods:{
        close(){
            this.dialog=false
        },
        open(item) {
            this.model.product_id = item.product_id
            this.model.cost= item.cost
            this.model.quantity = item.quantity
            this.dialog = true
        },
        update(){
            if (this.$refs.addForm.validate()) {
                this.$emit("updated", this.model);
                this.close()
            }
        },
        setProduct(product)
        {
            this.product=product
            if(product){
                this.model.cost = product.cost
                this.model.product = product
            }
        }
    }
}
</script>

<style>

</style>